import * as React from "react";
import { forwardRef } from "react";
const SvgArrowNarrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "arrow-narrow-left" }, /* @__PURE__ */ React.createElement("path", { id: "Icon", d: "M16.6667 10H3.33333M8.33333 5L3.33333 10L8.33333 15", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgArrowNarrowLeft);
export { ForwardRef as ReactComponent };
